"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.DEFAULT_CLEANUP_INTERVAL=void 0;const DEFAULT_CLEANUP_INTERVAL=exports.DEFAULT_CLEANUP_INTERVAL=30;
//# sourceMappingURL=constants.js.map